const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  const settings = {
    selectors: {
      logo: '[data-js-logo-header]',
      trigger: '[data-js-logo-stage]'
    },
    classes: {
      fadeIn: 'fade-in',
      visible: 'is-visible'
    }
  }

  const logo = document.querySelector(settings.selectors.logo)
  const trigger = document.querySelector(settings.selectors.trigger)

  if (!trigger || !logo) return

  const onScroll = () => {
    const triggerTop = trigger.getBoundingClientRect().top

    if (triggerTop < 0) {
      logo.classList.add(settings.classes.fadeIn)
    } else {
      logo.classList.remove(settings.classes.fadeIn)
    }
  }

  onScroll()

  window.addEventListener('scroll', onScroll, { passive: true })
})
